//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 18/09/2024
// Version : 1
// Description : Pantalla para editar proveedor de tanque
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
//
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Container,
  Grid,
  Box,
  TextField,
  IconButton,
  Button,
  Typography,
  Autocomplete,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";
import Notify from "../Notify";
import Alerta from "../Alerta";
import { logEventos } from "../../services/services";

function EditarProveedorTanque(props) {
  const [datosProveedor, setDatosProveedor] = useState(props.datos);
  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [notificacion, setNotificacion] = useState(false);
  const [error, setError] = useState(null);
  const [mensajeAlerta, setMensajeAlerta] = useState("");
  const [finalizar, setFinalizar] = useState();
  const [severityAlerta, setSeverityAlerta] = useState("");
  const [severitySnack, setSeveritySnack] = useState("");

  const [proveedor, setProveedor] = useState([]);
  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(
    props.datos
  );

  // useEffect para obtener los proveedores
  useEffect(() => {
    setDatosProveedor({ ...props.datos });
    setProveedorSeleccionado(props.datos);

    // Función para obtener los proveedores
    const obtenerProveedores = async () => {
      try {
        const response = await fetch(UrlApi + "/proveedores");
        if (response.ok) {
          const data = await response.json();
          setProveedor(data);
        } else {
          console.error("Error al obtener los proveedores.");
        }
      } catch (error) {
        console.error("Error al obtener los proveedores:", error);
      }
    };

    obtenerProveedores();
  }, [props.datos]);

  const handleClose = () => {
    return props.editar(false), props.tabla(true);
  };

  const [proveedorExiste, setProveedorExiste] = useState(false);

  const verificarProveedor = async (id_proveedor) => {
    const response = await fetch(
      UrlApi + `/tanque_proveedor/existe/${id_proveedor}`
    );
    const data = await response.json();
    if (data.length > 0) {
      // El proveedor ya existe
      setProveedorExiste(true);
    } else {
      // El proveedor no existe
      setProveedorExiste(false);
    }
  };

  useEffect(() => {
    if (proveedorSeleccionado) {
      verificarProveedor(proveedorSeleccionado.id);
    }
  }, [proveedorSeleccionado]);

//  console.log("VERIFICACION SI EXISTE", proveedorExiste);

  //Funcion para guardar
  const guardarEditar = async (e) => {
    logEventos(
      "Guardar editar el Proveedor Tanque",
      "Proveedores Tanques",
      "Se guardo la edicion del Proveedor Tanque",
      localStorage.getItem("user")
    );
    setDisBtn(true);
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/tanque_proveedor/" + datosProveedor.id_tanque_proveedor,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_proveedor: proveedorSeleccionado.id,
          usuario: localStorage.getItem("user"),
        }),
      }
    );
    if (response.ok === false) {
      console.log("ERROR EN API");
      const error = response && response.json();
      setError(error);
      setSeverityAlerta("error");
      setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      console.log("Conexión con api OK");
      try {
        //Parseo respuesta de la api a json()
        const json = await response.json();
        //si api me devuelve lo q le puse en message
        if (json.message) {
          //Si ese mensaje es "OK"
          if (json.message === "OK") {
            console.log("Guardado Satisfactoriamente");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("Guardado");
            setSeveritySnack("success");
          } else {
            console.log("res en api incorrecto. Revisar que sea 'OK'");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setSeveritySnack("error");
            setMensaje("Registro Guardado. REVISAR RESPUESTA DE API (E_S)");
          }
        } else if (json.sqlMessage) {
          json && setError(json);
          console.log(json);
          setMensajeAlerta(
            "SQL erróneo (" + json.code + " Errno: " + json.errno + " )"
          );
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          console.log(
            "Guardado. Advertencia: Actualizar respuesta de api. JSON invalido."
          );
          setNotificacion(true);
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("Guardado");
          setSeveritySnack("success");
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      }
    }
    handleClose();
  };

  //funcion para almacenar
  const almacenar = (e) => {
    setDatosProveedor({
      ...datosProveedor,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";

  return (
    <div>
      <br></br>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Editar proveedor tanque
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <form autoComplete="off">
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            p={3}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={12} sm={10} md={8} lg={6}>
                <Autocomplete
                  disableClearable
                  size="small"
                  required
                  style={style}
                  noOptionsText={"Proveedor INEXISTENTE"}
                  options={proveedor || []} // Asegúrate de que options siempre sea un array
                  autoHighlight
                  value={proveedorSeleccionado} // Pasa el valor actual al Autocomplete
                  getOptionLabel={(users) => users.razon_social}
                  onChange={(event, value) => setProveedorSeleccionado(value)}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.razon_social} - {option.nro_cuit}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                      }}
                      focused
                      size="small"
                      placeholder="Tipee para buscar..."
                      label="Proveedores de Tanque"
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver
              </Button>

              <Button
                variant="contained"
                onClick={guardarEditar}
                disabled={proveedorExiste} // Deshabilitar si el proveedor existe
                color="success"
              >
                Guardar Edición
              </Button>
            </Grid>
          </Box>
        </form>
      </Container>
      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={colormensaje}
          finalizar={setFinalizar}
          severity={severitySnack}
        />
      ) : null}
      {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
      {error && mensajeAlerta ? (
        <Alerta mensaje={mensajeAlerta} severity={severityAlerta} />
      ) : null}
    </div>
  );
}

export default EditarProveedorTanque;
